export enum AdditionalCertificateLevel {
    Level1 = 1,
    Level2 = 2,
}
